import {
  Button,
  Card,
  Modal,
  Stack,
  Tab,
  Tabs,
  Typography,
  useTheme,
  Box,
  createSvgIcon,
  Drawer,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { Check, CloseOutlined } from "@mui/icons-material";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import { ConfigGeral } from "./configGeral";
import { ReactComponent as IconReport } from "../../../assets/icons/IconEasyReport.svg";
import { ReactComponent as IconHeader } from "../../../assets/easyReport/icon/pageHeaderIcon.svg";
import HeaderConfig from "./headerConfig";
import api from "../../../services/api";
import { notifyOnPage } from "../../../utils/notifyOnPage";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ width: "100%" }}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

interface ConfiguracaoEasyReportProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  config: EasyReportConfig[];
  setConfig: React.Dispatch<React.SetStateAction<EasyReportConfig[]>>;
}

export default function ConfiguracaoEasyReport({
  open,
  setOpen,
  config,
  setConfig,
}: ConfiguracaoEasyReportProps) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [tabValue, setTabValue] = useState(0);
  const [hasChanges, setHasChanges] = useState(false);

  const [localConfig, setLocalConfig] = useState<EasyReportConfig[]>(config);
  const [openDrawer, setOpenDrawer] = useState(false);
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setLocalConfig(config);
  }, [config]);

  const EasyReportIcon = createSvgIcon(<IconReport />, "EasyReport");
  const HeaderIcon = createSvgIcon(<IconHeader />, "EasyReport");

  const listTabs = [
    { label: "Geral", icon: <EasyReportIcon />, value: 0 },
    { label: "Cabeçalho", icon: <HeaderIcon />, value: 1 },
  ];

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleCancel = () => {
    setOpen(false);
    setLocalConfig(config);
  };

  const handleSave = async () => {
    const sanitizedConfig = localConfig.map((item) => {
      if (item.nome === "header" && item.configuracoes) {
        const { imgSrc, ...restConfig } = item.configuracoes;
        return { ...item, configuracoes: restConfig };
      }
      return item;
    });
    try {
      const response = await api.post("easyReport/v2/config", {
        config: sanitizedConfig,
      });
      setConfig(response.data);
      setOpen(false);
      notifyOnPage(
        "/easyReportV2",
        "Configuração salva com sucesso",
        "success",
      );
    } catch (error) {
      notifyOnPage(
        "/easyReportV2",
        (error as any)?.response?.data?.error ||
          (error instanceof Error
            ? error.message
            : "Erro ao salvar configuração"),
        "error",
      );
    }
  };
  const handleDrawerToggle = () => {
    setOpenDrawer((prevState) => !prevState);
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleCancel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={isDownMd ? styles.containerMobile : styles.container}>
          <Stack
            sx={isDownMd ? styles.containerTabMobile : styles.containerTab}
          >
            {isDownMd ? (
              <>
                <IconButton sx={{ ml: 1 }} onClick={handleDrawerToggle}>
                  <MenuIcon />
                </IconButton>
                <Typography sx={styles.pageTitleMobile}>
                  Configurações Globais
                </Typography>
                <Drawer
                  elevation={0}
                  variant="temporary"
                  open={openDrawer}
                  onClose={() => setOpenDrawer(false)}
                  sx={styles.drawerMobile}
                  slotProps={{
                    paper: {
                      sx: {
                        backgroundColor: theme.palette.background.default,
                        py: 2,
                      },
                    },
                  }}
                >
                  <Tabs
                    orientation="vertical"
                    value={tabValue}
                    onChange={handleTabChange}
                    sx={{
                      ...styles.tabs,
                      minWidth: 250,
                    }}
                  >
                    {listTabs.map((tab, index) => (
                      <Tab
                        key={`tab-${index}`}
                        label={tab.label}
                        iconPosition="start"
                        icon={tab.icon}
                        value={tab.value}
                        sx={{
                          minHeight: "40px",
                          textTransform: "none",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          width: "100%",
                        }}
                      />
                    ))}
                  </Tabs>
                </Drawer>
              </>
            ) : (
              <>
                <Typography sx={styles.pageTitle}>Configurações</Typography>
                <Tabs
                  orientation="vertical"
                  value={tabValue}
                  onChange={handleTabChange}
                  sx={styles.tabs}
                >
                  {listTabs.map((tab, index) => (
                    <Tab
                      key={`tab-${index}`}
                      label={tab.label}
                      iconPosition="start"
                      icon={tab.icon}
                      value={tab.value}
                      sx={{
                        minHeight: "40px",
                        textTransform: "none",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        width: "100%",
                      }}
                    />
                  ))}
                </Tabs>
              </>
            )}
          </Stack>
          <Stack sx={styles.containerData}>
            <TabPanel value={tabValue} index={0}>
              <Typography variant="h6" gutterBottom>
                Configuração de Gerais
              </Typography>
              <ConfigGeral
                config={localConfig.find((c) => c.nome === "geral")}
                setConfig={(newConfig) =>
                  setLocalConfig((prev) => {
                    const exists = prev.some((c) => c.nome === "geral");
                    if (exists) {
                      return prev.map((c) =>
                        c.nome === "geral" ? { ...c, ...newConfig } : c,
                      );
                    } else {
                      return [...prev, newConfig];
                    }
                  })
                }
                setHasChanges={setHasChanges}
              />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <Typography variant="h6" gutterBottom>
                Configuração do Cabeçalho
              </Typography>
              <HeaderConfig
                config={localConfig.find((c) => c.nome === "header")}
                setConfig={(newConfig) =>
                  setLocalConfig((prev) => {
                    const exists = prev.some((c) => c.nome === "header");
                    if (exists) {
                      return prev.map((c) =>
                        c.nome === "header" ? { ...c, ...newConfig } : c,
                      );
                    } else {
                      return [...prev, newConfig];
                    }
                  })
                }
                setHasChanges={setHasChanges}
              />
            </TabPanel>
          </Stack>
          <Stack
            direction={"row"}
            sx={{ bottom: "10px", right: "10px", position: "absolute" }}
            spacing={1}
          >
            <Button
              onClick={handleCancel}
              sx={styles.buttomEnd}
              startIcon={<CloseOutlined />}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleSave}
              sx={styles.buttomEnd}
              startIcon={<Check />}
              color="secondary"
              disabled={!hasChanges}
            >
              Salvar
            </Button>
          </Stack>
        </Card>
      </Modal>
    </>
  );
}
